export const checkEmail = (_rule, value, callback) => {
  const validEmail = /^[\w-.+]+@([\w-]+\.)+[\w-]{2,4}$/.test(value);
  if (!validEmail) {
    callback('Please enter a valid email.');
  } else {
    callback();
  }
};

export const checkNumberString = (_rule, value, callback) => {
  const numDigits = parseInt(value).toString().length;
  if (numDigits === 10) {
    callback();
  } else {
    callback('Please enter numbers only. Max 10 digits.');
  }
};
